import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const JobDetailWrapper = styled.div`
  margin: 20px;
  line-height: 1.9;
  font-size: 16px;

  h2 {
    font-size: 32px;
    margin-bottom: 0;
    font-weight: bold;
    text-transform: capitalize;

    span {
      margin-left: 15px;
      font-size: 11px;
      font-weight: 600;
    }
  }
  .location {
    opacity: 0.55;
    font-size: 18px;
  }
  .description {
    max-width: 980px;
    p {
    }
    h3 {
      font-weight: 700;
      font-size: 20px;
    }
  }

  .jobDetailHeaderWrapper {
    display: flex;
    justify-content: space-between;
    text-align: left !important;
  }
  @media only screen and (max-width: 480px) {
    .jobDetailHeaderWrapper {
      flex-direction: column;
    }
    .location {
      margin-bottom: 5px;
    }
    h2 {
      font-size: 22px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      span {
        margin: 0;
      }
    }

    .ant-btn {
      width: 100%;
    }
  }
`
